export default {
  name: 'mainfooter',
  computed: {
    showRicsInFooter () {
      let RicsInvisibleAt = ['index']
      if (RicsInvisibleAt.includes(this.$route.name)) {
        return false
      } else {
        return true
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/_globals/mainfooter/mainfooter.js